import NextLink from "next/link";
import { DestinationCardData } from "config/homePageConfig";
import { FALLBACK_LOGO_IMAGE } from "constant";
const DestinationCard = ({
  destination,
  isLazy = true
}: {
  destination: DestinationCardData;
  isLazy?: boolean;
}) => {
  return <NextLink href={destination.path} className='block w-[234px] flex-shrink-0 overflow-hidden rounded-2xl bg-white md:w-[400px]' data-sentry-element="NextLink" data-sentry-component="DestinationCard" data-sentry-source-file="DestinationCard.tsx">
      <div className='aspect-[400/365] w-full rounded-t-2xl bg-cover bg-center' style={{
      backgroundImage: `url(${destination.image || FALLBACK_LOGO_IMAGE})`
    }} />

      <div className='px-3 py-2 text-center md:px-5 md:py-3'>
        <h3 className='truncate text-xs font-semibold leading-[0.96em] text-secondary-500 md:text-xl md:leading-[0.96em]'>
          {destination.title}
        </h3>
        <p className='mt-1 text-[9px] leading-[1.28em] text-Gray-700 underline md:mt-2 md:text-[15px]'>
          {destination.viewText}
        </p>
      </div>
    </NextLink>;
};
export default DestinationCard;